/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Best_HighlightInputs */

const et_plan_best_highlight = /** @type {(inputs: Plan_Best_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nähtav 80%+ tulemustest.`)
};

const en_plan_best_highlight = /** @type {(inputs: Plan_Best_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible in 80%+ of results.`)
};

/**
* | output |
* | --- |
* | "Visible in 80%+ of results." |
*
* @param {Plan_Best_HighlightInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_best_highlight = /** @type {((inputs?: Plan_Best_HighlightInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Best_HighlightInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_best_highlight(inputs)
	return en_plan_best_highlight(inputs)
});